<template>
  <div class="animated revealUp" style="zoom: 0.8">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Merchandise Stock</div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <multiselect
              :options="Cinemas"
              v-model="selectedCinema"
              :placeholder="''"
              label="cine_name"
              track-by="cine_id"
              @input="onSelectCinema($event, 'select')"
              @remove="onSelectCinema($event, 'remove')"
            ></multiselect>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedMerchandise ? 'shift-up' : ''"
              >Merchandise</label
            >
            <multiselect
              :options="AllMerchandiseItems"
              v-model="selectedMerchandise"
              :placeholder="''"
              label="merchandise_name"
              track-by="merchandise_id"
              @input="onSelectMerchandise($event, 'select')"
              @remove="onSelectMerchandise($event, 'remove')"
            ></multiselect>
          </div>
        </div>

        <div class="col-md-2 mb-3">
          <button class="btn-blue" @click.prevent.stop="onFetch()">
            {{ $t("Fetch") }}
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <div
          v-if="VariantsStock && VariantsStock.length > 0"
          class="d-flex justify-content-end mb-4 align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="pdfFile"
            :href="BASE_URL + pdfFile"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img
              src="@/assets/img/icons/pdf-icon.svg"
              height="25"
              width="25"
              class="mx-1"
            />
          </a>
          <a
            v-if="excelFile"
            :href="BASE_URL + excelFile"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
      <div class="">
        <table class="swc-report-table text-center border" border="1">
          <thead>
            <tr>
              <th class="text-left" style="width: 370px">Variant Name</th>
              <th class="text-center">Available Stock</th>
              <th class="text-center">
                {{ $t("physical") }} {{ $t("stock") }}
              </th>
              <th class="text-center">Variance</th>
              <th class="text-center">{{ $t("Reason") }}</th>
              <th class="text-center">Active</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(variantObj, variantIndex) in VariantsStock"
              :key="variantIndex"
            >
              <td class="text-left font-weight-bold">
                <div
                  v-if="variantObj.size_name && variantObj.color_name"
                  class="w-50"
                >
                  <span>{{ variantObj.size_name }}</span>
                  <span>-</span>
                  <span>{{ variantObj.color_name }}</span>
                </div>
                <span v-if="variantObj.size_name && !variantObj.color_name">{{
                  variantObj.size_name
                }}</span>
                <span v-if="!variantObj.size_name && variantObj.color_name">{{
                  variantObj.color_name
                }}</span>
              </td>
              <td class="text-center">
                {{ parseFloat(variantObj.stock_available) }}
              </td>
              <td class="text-center">
                <input
                  style="border-radius: 5px"
                  class="w-100 form-control form-control-sm"
                  placeholder
                  type="number"
                  v-model="variantObj.new_stock"
                  @input="calculateVariance($event, variantObj)"
                />
              </td>
              <td class="text-center">
                {{ parseFloat(variantObj.variance) }}
              </td>
              <td class="text-center">
                <input
                  style="border-radius: 5px"
                  class="w-100 form-control form-control-sm"
                  placeholder
                  type="text"
                  v-model="variantObj.reason"
                />
              </td>
              <td class="text-center">
                <b-form-checkbox
                  v-model="variantObj.is_stock_disabled"
                  unchecked-value="Y"
                  value="N"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </td>
              <!-- <td class="px-0" v-if="parseFloat(variantObj.variance)">
                <button
                  class="btn-blue mx-0 p-0"
                  @click.prevent.stop="updateStock(variantObj)"
                >
                  {{ $t("Update") }}
                </button>
              </td> -->
              <td></td>
            </tr>
            <tr v-if="VariantsStock.length == 0">
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row" v-if="VariantsStock.length">
          <div
            class="d-flex justify-content-center align-items-center my-3 w-100"
          >
            <button
              class="btn-blue mx-0 p-0"
              @click.prevent.stop="updateAllStock()"
            >
              {{ $t("Update") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import _ from "lodash";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      VariantsStock: [],
      AllMerchandiseItems: [],
      selectedMerchandise: null,
      mainPayload: {
        cinema_id: null,
        merchandise_id: null,
      },
      btnDisbaled: false,
      searchCinema: "",
      isRoleID: true,
      isRoleID1: null,
      getitem: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      listView: true,
      Cinemas: [],
      selectedCinema: "",
      selectedReason: "",
      excelFile: "",
      pdfFile: "",
      selectedCinemaObject: {},

      debounce: null,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
    };
  },
  computed: {},
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.isRoleID1 = this.secureStore.get("USINFO").role_id;

    const { merchandise_id } = this.$route.query;
    this.mainPayload["merchandise_id"] = merchandise_id || null;
  console.log('merchandise_id', merchandise_id);
  
    this.getCinemas(obj);
    this.getMerchandiseItems(merchandise_id);
  },

  methods: {
    updateAllStock() {
      let stockArray = this.VariantsStock.filter((x) => x.variance);
      if (stockArray && stockArray.length) {
        let errIndex = null;
        let errCount = 0;
        let errMsg = "";

        stockArray.forEach((_stock) => {
          if (!_stock["variance"]) {
            errMsg = "Add some stock";
            errCount++;
          }
        });

        if (!this.mainPayload["cinema_id"]) {
          errMsg = "Please Select Cinema";
          errCount++;
        } else if (!this.mainPayload["merchandise_id"]) {
          errMsg = "Please Select Merchandise";
          errCount++;
        }

        if (errCount > 0) {
          return this.$toasted.show(errMsg);
        } else {
          let loader = this.$loading.show();
          MasterService.UpdateMerchandiseStock({
            ...this.mainPayload,
            Variants: stockArray,
          })
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(
                  data.message || "Stock added successfully"
                );
                this.$router.push({
                  path: "/cinema-manager/merchandise",
                });
              } else {
                this.$toasted.show(data.message || "Error");
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
            });
        }
      } else {
        return this.$toasted.show("Please enter valid stock to uppdate.");
      }
    },
    calculateVariance(event, variantObj) {
      let value = event.target.value;
      let available_stock = parseFloat(variantObj["stock_available"] || 0);
      variantObj["variance"] = parseFloat(value - available_stock);
    },
    getMerchandiseItems: function (merchandise_id) {
      this.AllMerchandiseItems = [];
      let payload = {
        tableName: "ms_merchandise",
        merchandise_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.AllMerchandiseItems = data.Records.filter(
                (x) => x.is_combo_pack == "N"
              );

              if (merchandise_id) {
                let checkItem = this.AllMerchandiseItems.filter(
                  (x) => x.merchandise_id == merchandise_id
                );
                if (checkItem && checkItem.length) {
                  this.selectedMerchandise = checkItem[0];
                  this.mainPayload["merchandise_id"] =
                    checkItem[0]["merchandise_id"] || null;
                }
              }
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    onSelectMerchandise(merchandise, type = "select") {
      if (type == "remove") {
        this.mainPayload["merchandise_id"] = null;
      } else {
        this.mainPayload["merchandise_id"] = merchandise["merchandise_id"];
      }
    },
    onFetch: function () {
      this.getMerchandiseVariants();
    },
    getMerchandiseVariants() {
      let payload = {
        ...this.mainPayload,
      };
      MasterService.GetAllVariantsStock(payload).then((response) => {
        const { data } = response;
        if (data.status && data.Records && data.Records.length) {
          data.Records.forEach((element) => {
            element["stock_available"] = parseFloat(
              element["stock_available"] || 0
            );
            element["new_stock"] = parseFloat(element["stock_available"] || 0);
            element["reason"] = "";
            element["variance"] = 0;
            element["is_stock_disabled"] = element["is_stock_disabled"] || "N";
          });
          this.VariantsStock = data.Records || [];
        } else {
          this.$toasted.show(data.message || "Something Went Wrong!");
        }
      });
    },
    getCinemas: function (cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function (params, type = "select") {
      if (type == "remove") {
        this.mainPayload["cinema_id"] = null;
        this.selectedCinema = "";
      } else {
        this.mainPayload["cinema_id"] = params.cine_id;
        this.selectedCinema = params;
      }
    },
    onSortValue(columnName, orderBy) {
      if (this.selectedid.length == 0) {
        return this.$toasted.show("Please select cinema");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getPurchaseOrderList(this.selectedid);
    },
    onSearch: function () {
      this.getPurchaseOrderList(this.selectedid);
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    goToRoute: function (path, { stock_in_id }) {
      this.$router.push({
        path: path,
        query: {
          stock_in_id: stock_in_id,
        },
      });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    OnFinalSubmit: function () {
      let payload = {
        ...this.stock_in_details,
        stock_in_id: this.stock_in_id,
        stock_quantity: this.stock_quantity,
      };
      PosFnbService.updatStockDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.$refs.updateStock.hide();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        console.log("this.selectedid :", this.selectedid);
        this.getPurchaseOrderList(this.selectedid);
      } else if (this.isRoleID1 == 1 || this.isRoleID1 == 2) {
        this.currentPage = event;
        this.getPurchaseOrderList(this.selectedid);
      } else {
        this.currentPage = event;
        this.getPurchaseOrderList(this.getitem);
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>

<style>
.stockUOM-dropdowm .multiselect__content-wrapper {
  width: 160px !important;
}

.table-wrapper {
  /* overflow-x: scroll !important; */
}

.table-wrapper .list-view-table {
  /* width: auto!important; */
  table-layout: auto;
  /* white-space: nowrap; */
}

.table-wrapper .list-view-table th {
  padding: 5px 10px 5px 10px;
}

.bg-red {
  color: red;
  background-color: transparent !important;
}

.bg-green {
  color: green;
}

.bg-transparent {
  background-color: transparent !important;
  color: black !important;
}

.noVendorRate {
  opacity: 0.5;
  color: red;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/MerchandiseStock.vue